// extracted by mini-css-extract-plugin
export var fullWidthButton = "_hr-0";